import gql from 'graphql-tag';

const getVideoPaymentStatusQuery = gql`
  query getVideoPaymentStatus(
    $videoId: String!
  ) {
    getVideoPaymentStatus(
      videoId: $videoId
    ) {
      status
      totalAmountPending 
    }
  }
`;

export default (() => ({
  query: getVideoPaymentStatusQuery,
  module: 'payments',
  ignoreCache: true,
  buildVariables: ({ videoId }) => ({
    videoId
  })
}));